<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'dsaManagement.users'">
    <div class="panel">
      <div class="page-header">
        <div class="header-title-section">
          <h1 class="header-title">{{ t('title') }}</h1>
          <p class="header-subtitle">{{ t('subtitle') }}</p>
        </div>
        <htx-button variant="primary" icon="person_add" (click)="addUser()">
          {{ t('addButton') }}
        </htx-button>
      </div>

      <htx-table
        [data]="users()"
        [columns]="columnConfig()"
        [loading]="loading()"
        [rowIdField]="'iamId'"
      ></htx-table>
    </div>
  </div>

  <ng-template #statusTemplate let-row>
    <htx-badge
      [text]="
        (row.enabled === false
          ? 'dsaManagement.users.status.inactive'
          : 'dsaManagement.users.status.active') | transloco
      "
      [variant]="row.enabled === false ? 'danger' : 'success'"
    ></htx-badge>
  </ng-template>

  <ng-template #actionTemplate let-row>
    @let user = getTyped(row);
    <div class="action-buttons">
      <htx-button
        variant="tertiary"
        icon="edit"
        [iconOnly]="true"
        [tooltip]="'dsaManagement.users.edit.action' | transloco"
        (click)="editUser(user)"
      ></htx-button>
      @if (user.enabled === false) {
        <htx-button
          variant="tertiary"
          icon="check_circle"
          [iconOnly]="true"
          [tooltip]="'dsaManagement.users.activate.action' | transloco"
          (click)="toggleStatus(user)"
        ></htx-button>
      } @else {
        <htx-button
          variant="tertiary"
          icon="block"
          [iconOnly]="true"
          [tooltip]="'dsaManagement.users.deactivate.action' | transloco"
          (click)="toggleStatus(user)"
        ></htx-button>
      }
      <htx-button
        variant="tertiary"
        icon="delete"
        [iconOnly]="true"
        [tooltip]="'dsaManagement.users.delete.action' | transloco"
        (click)="deleteUser(user)"
      ></htx-button>
    </div>
  </ng-template>
</app-protected-content>
